import React from 'react'
import { Box } from '@mui/material'
import { Failure } from '../api/failureReason'

// Spans, not AlertTitle: it also renders inside a dialog's error Typography.
const FailureMessage = ({ failure }: { failure: Failure }) => (
  <>
    <Box component="span" sx={{ display: 'block', fontWeight: 600 }}>
      {failure.summary}
    </Box>
    {failure.reason}
  </>
)

export default FailureMessage
